import React from "react";

export default function Icon02() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="#FEF3E7" />
      <g clipPath="url(#clip0_134_46728)">
        <path
          d="M22.6667 9.33325L15.3333 16.6666"
          stroke="#F7683B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.6667 9.33325L18 22.6666L15.3333 16.6666L9.33334 13.9999L22.6667 9.33325Z"
          stroke="#F7683B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_134_46728">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
